import styled from "styled-components";

export const ImageIcon = styled.img<{ maxSize?: string }>`
    max-width: ${(props) => props.maxSize ?? "40px"};
    max-height: ${(props) => props.maxSize ?? "40px"};
    width: auto;
    height: auto;
    object-fit: contain;
`;
